module.exports = __webpack_public_path__ + "static/media/course-structure-active.1d403004.svg";